import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { ProgramOrganizationType } from '../../../models/program-organization.model';
import { BusinessRole } from '../../../models/role.model';
import { selectHasBusinessRole, selectRolesLoaded, selectViewMode } from '../../../store/selectors/pd.selectors';
import { RoutesName } from '../constants/routes-name';

export const performanceAdminRedirectGuard: CanActivateFn = (route) => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectRolesLoaded).pipe(
    filter(loaded => loaded),
    take(1),
    switchMap(() => combineLatest([store.select(selectHasBusinessRole(BusinessRole.PerformanceAdmin)), store.select(selectHasBusinessRole(BusinessRole.UtilityDispatchUser)), store.select(selectViewMode)]).pipe(take(1))),
    map(([isPerformanceAdmin, isUtilityDispatchUser, viewMode]) => {
      const viewModeRoute: Record<ProgramOrganizationType, RoutesName> = {
        [ProgramOrganizationType.Program]: RoutesName.PROGRAM,
        [ProgramOrganizationType.Organization]: RoutesName.ORGANIZATION,
      };
      const target = (isPerformanceAdmin || isUtilityDispatchUser) ? (viewModeRoute[viewMode] ?? RoutesName.PROGRAM) : RoutesName.ORGANIZATION;
      return router.createUrlTree([target], { queryParams: route.queryParams });
    })
  );
};
